import { render, staticRenderFns } from "./TestOk.vue?vue&type=template&id=212c50e0&scoped=true&"
import script from "./TestOk.vue?vue&type=script&lang=js&"
export * from "./TestOk.vue?vue&type=script&lang=js&"
import style0 from "./TestOk.vue?vue&type=style&index=0&id=212c50e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c50e0",
  null
  
)

export default component.exports